import React, { useState } from 'react';
import { Table, Switch, Input, InputNumber, Spin } from 'antd';
import { TopMenuSearch } from '../../layout/style';
import AuthInfo from '../../components/utilities/auth-info/info';
import BusinessHeader from '../../components/BusinessHeader';
import SetupGuide from '../../components/setup-guide/SetupGuide';
import NotificationBox from '../../components/utilities/auth-info/notification';
import downArrow from '../../assets/images/downArrow.svg';
import { Cards } from '../../components/cards/frame/cards-frame';
import './auto-sms.css';

const AutoSMS = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const [isAutoSmsEnabled, setIsAutoSmsEnabled] = useState(true);
    const [smsTemplate, setSmsTemplate] = useState('Sorry we missed you! Book here: {link}');
    const [delaySeconds, setDelaySeconds] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const handlePopupClick = () => {
        setOpenPopup(!openPopup);
    };

    const handleSaveSettings = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            // Toast notification would go here
        }, 1000);
    };

    // Sample data for the table
    const smsData = [
        {
            key: '1',
            callerNumber: '+1 (555) 123-4567',
            status: 'Missed',
            autoReplied: 'Yes',
            bookingStatus: 'Booked',
            timestamp: '2024-01-15 10:30 AM',
        },
        {
            key: '2',
            callerNumber: '+1 (555) 234-5678',
            status: 'Answered',
            autoReplied: 'No',
            bookingStatus: 'Not Booked',
            timestamp: '2024-01-15 11:15 AM',
        },
        {
            key: '3',
            callerNumber: '+1 (555) 345-6789',
            status: 'Missed',
            autoReplied: 'Yes',
            bookingStatus: 'Booked',
            timestamp: '2024-01-15 02:45 PM',
        },
        {
            key: '4',
            callerNumber: '+1 (555) 456-7890',
            status: 'Missed',
            autoReplied: 'Yes',
            bookingStatus: 'Not Booked',
            timestamp: '2024-01-15 03:20 PM',
        },
        {
            key: '5',
            callerNumber: '+1 (555) 567-8901',
            status: 'Answered',
            autoReplied: 'No',
            bookingStatus: 'Booked',
            timestamp: '2024-01-15 04:10 PM',
        },
    ];

    const columns = [
        {
            title: 'Caller Number',
            dataIndex: 'callerNumber',
            key: 'callerNumber',
            render: (text) => <span className="fw-500">{text}</span>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text) => (
                <span className={`status-badge status-${text.toLowerCase()}`}>
                    {text}
                </span>
            ),
        },
        {
            title: 'Auto-Replied',
            dataIndex: 'autoReplied',
            key: 'autoReplied',
            render: (text) => (
                <span className={`reply-badge reply-${text.toLowerCase()}`}>
                    {text}
                </span>
            ),
        },
        {
            title: 'Booking Status',
            dataIndex: 'bookingStatus',
            key: 'bookingStatus',
            render: (text) => (
                <span className={`booking-badge booking-${text.toLowerCase().replace(' ', '-')}`}>
                    {text}
                </span>
            ),
        },
        {
            title: 'Timestamp',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (text) => <span className="text-gray">{text}</span>,
        },
    ];

    return (
        <>
            <div className={`container-fluid`}>
                <div className={`row`}>
                    <div className={`col-12 px-0 bg-ff br-top-left-22`}>
                        <div className={`container-fluid`}>
                            <div className={`row justify-content-between`}>
                                <div className={`col-lg-9 col-md-7 col-12 px-md-24 pt-24 px-0px`}>
                                    <BusinessHeader handlePopupClick={handlePopupClick} />
                                </div>
                                <div className={`col-lg-3 col-md-5 col-12 px-md-24 pt-md-24px`}>
                                    <div className={`container-fluid`}>
                                        <div className={`row align-items-center justify-content-between`}>
                                            <div className={`col px-0`}>
                                                <TopMenuSearch className={`d-md-block d-none`}>
                                                    <div className="d-flex gap-3 align-items-center justify-content-end">
                                                        <NotificationBox />
                                                        <AuthInfo />
                                                    </div>
                                                </TopMenuSearch>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`row`}>
                                <div className={`col-12 px-md-24 pt-24 min-h-100vh`}>
                                    <div className={`auto-sms-container`}>
                                        <div className={`container-fluid`}>
                                            {/* Header Section */}
                                            <div className={`row justify-content-between pb-32`}>
                                                <div className={`col-md col-auto px-0 max-w-sm-250`}>
                                                    <h6 className={`mb-8 f-28 fw-normal poly c-0f151d`}>
                                                        Auto SMS Reply
                                                    </h6>
                                                    <h6 className={`m-0 f-16 fw-normal poppins text-gray`}>
                                                        Manage automatic SMS responses for missed calls
                                                    </h6>
                                                </div>
                                            </div>

                                            {/* Settings Card */}
                                            <div className={`row pb-32`}>
                                                <div className={`col-12 px-0`}>
                                                    <Cards border={true} bodypadding="24px">
                                                        <div className="auto-sms-settings">
                                                            {/* Toggle */}
                                                            <div className="setting-item">
                                                                <div className="setting-header">
                                                                    <label className="setting-label">
                                                                        Auto SMS Reply
                                                                    </label>
                                                                    <Switch
                                                                        checked={isAutoSmsEnabled}
                                                                        onChange={setIsAutoSmsEnabled}
                                                                        style={{
                                                                            backgroundColor: isAutoSmsEnabled ? '#2B5C35' : '#d9d9d9',
                                                                        }}
                                                                    />
                                                                </div>
                                                                <p className="setting-status">
                                                                    {isAutoSmsEnabled ? 'ON' : 'OFF'}
                                                                </p>
                                                            </div>

                                                            {/* SMS Template */}
                                                            <div className="setting-item">
                                                                <label className="setting-label">
                                                                    SMS Template
                                                                </label>
                                                                <Input.TextArea
                                                                    value={smsTemplate}
                                                                    onChange={(e) => setSmsTemplate(e.target.value)}
                                                                    placeholder="Enter SMS template"
                                                                    rows={4}
                                                                    maxLength={160}
                                                                    className="sms-textarea"
                                                                />
                                                                <p className="char-count">
                                                                    {smsTemplate.length}/160 characters
                                                                </p>
                                                            </div>

                                                            {/* Delay */}
                                                            <div className="setting-item">
                                                                <label className="setting-label">
                                                                    Delay (seconds)
                                                                </label>
                                                                <InputNumber
                                                                    value={delaySeconds}
                                                                    onChange={setDelaySeconds}
                                                                    min={1}
                                                                    max={300}
                                                                    className="delay-input"
                                                                />
                                                                <p className="setting-hint">
                                                                    Wait time before sending SMS (1-300 seconds)
                                                                </p>
                                                            </div>

                                                            {/* Save Button */}
                                                            <button
                                                                onClick={handleSaveSettings}
                                                                disabled={isLoading}
                                                                className="btn rounded-pill mt-3"
                                                                style={{
                                                                    backgroundColor: '#2B5C35',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    padding: '8px 24px',
                                                                    fontWeight: '500',
                                                                }}
                                                            >
                                                                {isLoading ? <Spin /> : 'Save Settings'}
                                                            </button>
                                                        </div>
                                                    </Cards>
                                                </div>
                                            </div>

                                            {/* Table Section */}
                                            <div className={`row pb-32`}>
                                                <div className={`col-12 px-0`}>
                                                    <div className="auto-sms-table">
                                                        <h6 className={`mb-24 f-20 fw-normal poly c-0f151d`}>
                                                            Call History
                                                        </h6>
                                                        <div className="table-wrapper">
                                                            <Table
                                                                dataSource={smsData}
                                                                columns={columns}
                                                                pagination={{
                                                                    defaultPageSize: 10,
                                                                    total: smsData.length,
                                                                }}
                                                                rowKey="key"
                                                                className="auto-sms-table-ant"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SetupGuide openPopup={openPopup} handlePopupClick={handlePopupClick} />
        </>
    );
};

export default AutoSMS;
